import * as React from 'react';

// static image
import tel from '../../../../assets/images/solutions.png';
import educationPageImg from '../../../../assets/images/EducationPage.jpg';

import { ReactComponent as Viber } from '../../../../assets/icons/viber.svg';
import { ReactComponent as Telegram } from '../../../../assets/icons/telegram.svg';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

// types
import {
  ButtonGroups,
  ButtonSizes,
  ButtonTypes,
} from '../../../../atoms/Button/types';

import Button from '../../../../atoms/Button';

// styles
import {
  Wrapper,
  Before,
  Outer,
  Inner,
  Image,
  BigImage,
  WidgetOuter,
  Download,
  ButtonContainer,
  Row,
  CompendiumUls,
  LeftText,
  StyledP,
  MainP,
  StyledLi,
  StyledH5,
  IconItem,
  Outer2,
  Outer3,
  UnauthorizedContainer,
  MainPInline,
  OuterReverse,
  RowCustom,
} from '../styles';

// static data
import { digitalSolutions } from '../data';

export const EducationalSites = () => {
  // locales hook
  const { t } = useTranslation();

  return (
    <Wrapper>
      <MainP>{digitalSolutions.subtitle}</MainP>

      <Outer3>
        <Image src={tel} alt="Телефон" />

        <Inner>
          <h3>{digitalSolutions.telegram.title}</h3>
          <StyledP>{digitalSolutions.telegram.p3}</StyledP>
          <StyledP>{digitalSolutions.telegram.p2}</StyledP>
          <StyledP>
            <b>“Кардіопростір”</b>
            {digitalSolutions.telegram.p4}
          </StyledP>

          <RowCustom>
            <ButtonContainer>
              <a
                href="https://t.me/joinchat/AAAAAE_nsfR1F7TeevcsUQ?fbclid=IwAR1AloJCL5Wjj0cj8rQ54KosHjqk6fBa0RO6WN_Qf1okRFXTGSn77lEXpTQ"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  text={t(
                    translations.digitalSolutions.actions.connectTelegram,
                  )}
                  type={ButtonTypes.Button}
                  group={ButtonGroups.Secondary}
                  size={ButtonSizes.SuperLarge}
                  loading={false}
                >
                  <IconItem>
                    <Telegram width={26} height={26} />
                  </IconItem>
                </Button>
              </a>
            </ButtonContainer>
            <ButtonContainer>
              <a
                href="https://invite.viber.com/?g2=AQA4IZM%2BDHV9oUydVCtysSkprMuPFzPQo2MdKE9GuI6rGVIUhIQOsCjgIh69hrf5&lang=uk"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  text={t(translations.digitalSolutions.actions.connectViber)}
                  type={ButtonTypes.Button}
                  group={ButtonGroups.Secondary}
                  size={ButtonSizes.SuperLarge}
                  loading={false}
                >
                  {' '}
                  <IconItem>
                    <Viber width={26} height={26} />
                  </IconItem>{' '}
                </Button>
              </a>
            </ButtonContainer>
          </RowCustom>
        </Inner>
      </Outer3>

      <WidgetOuter>{/*<AppStoreWidget />*/}</WidgetOuter>

      <div>
        <BigImage src={educationPageImg} alt="" />

        <LeftText>
          <h3>{digitalSolutions.digitalForVisitors.subtitle3}</h3>

          <StyledP>{digitalSolutions.digitalForVisitors.p8}</StyledP>
          <StyledP>{digitalSolutions.digitalForVisitors.p9}</StyledP>
          <StyledP>{digitalSolutions.digitalForVisitors.p10}</StyledP>
          <StyledP>{digitalSolutions.digitalForVisitors.p11}</StyledP>
          <StyledP>{digitalSolutions.digitalForVisitors.p17}</StyledP>
          <Before>
            {digitalSolutions.digitalForVisitors.p18}
            <a
              href="https://patient-info.org.ua/index.html"
              target="_blank"
              rel="noreferrer"
            >
              посиланням.
            </a>
          </Before>

          <StyledH5>{digitalSolutions.digitalForVisitors.p19}</StyledH5>
        </LeftText>
      </div>
    </Wrapper>
  );
};

export default EducationalSites;
